import { Input, Label } from './RadioButton.styles';
import type { RadioButtonProps } from './RadioButton.types';

export function RadioButton({ name, value, label, checked, onChange, disabled }: RadioButtonProps) {
  return (
    <Label data-disabled={disabled}>
      <Input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
      />
      {label}
    </Label>
  );
}
